import { Component, OnInit, OnDestroy, ViewChild, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
// import { DetailPageService } from '@services/support/detail-page.service';
import { Subscription } from 'rxjs';
import { User } from '@models/User';
import { first } from 'rxjs/operators';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { SessionService } from '@services/remote/session.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { LoaderService } from '@services/support/loader.service';
import { SnackbarService } from '@services/support/snackbar.service';
import { AuthService } from '@services/auth.service';
import { DetailPageService } from '@services/detail-page.service';
import { AlertModalComponent } from 'src/app/components/modals/alert-modal/alert-modal.component';
import { TicketService } from '@services/ticket.service';
import { ModalService } from '@services/remote/modal.service';
import { TicketDetailComponent } from '../../tickets/ticket-detail/ticket-detail.component';
import { NovaIngestService, NovaIngestJob, NovaIngestJobResult, NOVA_TERMINAL_STATUSES } from '@services/remote/nova-ingest.service';

@Component({
    selector: 'app-session-details',
    templateUrl: './session-details.component.html',
    styleUrls: ['./session-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SessionDetailsComponent implements OnInit, OnDestroy {

  @ViewChild("pickTicketTemplate", { static: true }) private pickTicketTemplate: TemplateRef<any>;

  session: any;
  userSessions: boolean;

  sessionSub: Subscription = null;
  attachedTicketSub: Subscription = null;

  participants: string[] = [];

  ticketAvailable: boolean = false;

  users: User[] = [];
  userSub: Subscription = null;

  selectedTicket = null;

  attachedTicketId: string = null;
  attachedTicket: any = null;

  licenseType: string = "expert_user_based";

  exportRecipients: any[] = [];
  validMailValidator = Validators.pattern(/^$|^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/);
  invalidEmailError = { pattern: "" };
  emailPholder = "";
  emailSecPholder = "";

  sessionExportEnabled: boolean = false;
  wipeSessionDataBtnEnabled: boolean = false;
  webdavEnabled: boolean = false;
  accountDataSub: Subscription = null;
  subscriptions: Subscription[] = [];

  showCheckboxes = false;
  downloadSelectedFiles = false;
  showDownloadButton: boolean = false;

  novaAvailable: boolean = false;

  // Nova ingest state
  novaStatus: string | null = null;
  novaStatusMessage: string | null = null;
  novaResult: NovaIngestJobResult | null = null;
  novaErrorMessage: string | null = null;
  novaIsRequesting: boolean = false;
  novaInitialLoading: boolean = true;
  novaConfirmRemove: boolean = false;
  novaIsDeleting: boolean = false;
  private novaPollTimer: any = null;
  private readonly NOVA_POLL_INTERVAL = 5000;

  constructor(
    private authService: AuthService,
    private sessionService: SessionService,
    private modalService: BsModalService,
    private templateModalService: ModalService,
    private loaderService: LoaderService,
    private translateService: TranslateService,
    private snackBarService: SnackbarService,
    private detailPageService: DetailPageService,
    private ticketService: TicketService,
    private novaIngestService: NovaIngestService
  ) { }

  ngOnInit() {
    // this.route.queryParams.subscribe(params => {
    //   const id = params['id'];
    //   this.sessionSub = this.sessionService.getSession(id).subscribe(res => {
    //     this.session = res
    //   })
    // })
    this.translateService.get('MAIN.SETTINGS.EMAIL_RECIPIENTS.PLACEHOLDER').pipe(first()).toPromise().then(tr => {
      this.emailPholder = tr;
    });
    this.translateService.get('MAIN.SETTINGS.EMAIL_RECIPIENTS.SECONDARY_PLACEHOLDER').pipe(first()).toPromise().then(tr => {
      this.emailSecPholder = tr;
    });
    this.translateService.get('MAIN.SETTINGS.EMAIL_RECIPIENTS.INVALID_EMAIL').pipe(first()).toPromise().then(tr => {
      this.invalidEmailError.pattern = tr;
    });

    this.authService.getAccountData().then(account => {
      const addOns = account?.data?.accountData?.add_ons || {};
      const features = account?.data?.accountData?.features || {};
      this.sessionExportEnabled = !!addOns.sessionexport;
      this.wipeSessionDataBtnEnabled = !!addOns.wipesessiondatabtn;
      this.webdavEnabled = !!addOns.webdav;
      this.licenseType = account?.data?.accountData?.license?.type || this.licenseType;
      this.ticketAvailable = this.ticketAvailable || !!addOns.ticket || !!features.ticket || !!features.tickets || !!features.ticket_system;
      this.novaAvailable = !!addOns.aiassistant;
      this.refreshAttachedTicket();
      if (this.novaAvailable) {
        this.fetchNovaIngestStatus();
      } else {
        this.novaInitialLoading = false;
      }
    })

    this.sessionSub = this.sessionService.getSession(this.session.id).subscribe(session => {
      const mergedSession = { ...this.session, ...session };
      if (this.userSessions) {
        if (Array.isArray(this.session?.users) && !Array.isArray(session?.users)) {
          mergedSession.users = this.session.users;
        }
        if (Array.isArray(this.session?.guest_users) && !Array.isArray(session?.guest_users)) {
          mergedSession.guest_users = this.session.guest_users;
        }
      }
      this.session = mergedSession;
      const attachedTicketId = session.attached_ticket || null;
      if (this.attachedTicketId !== attachedTicketId) {
        this.attachedTicketId = attachedTicketId;
        this.refreshAttachedTicket();
      }
    });

    this.userSub = this.authService.getAllUsers().subscribe((users: User[]) => {
      this.users = users.sort((a, b) => a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase()));
    });
  }

  onGetExport() {
    const roomId = this.session.room ? this.session.room.id : this.session.room_id;
    this.sessionService.sessionExportRequest.next([roomId, this.session.id, !!this.session.end_time]);
  }

  toggleSelection() {
    this.showCheckboxes = !this.showCheckboxes;
    this.showDownloadButton = !this.showDownloadButton;
  }

  onDownloadStarted() {
    if (this.downloadSelectedFiles) {
      this.downloadSelectedFiles = false;
    } else {
      setTimeout(() => {
        this.downloadSelectedFiles = true;
        setTimeout(() => {
          this.downloadSelectedFiles = false;
        }, 0);
      }, 0);
    }
  }

  ngOnDestroy() {
    if (this.accountDataSub) { this.accountDataSub.unsubscribe() }
    if (this.sessionSub) { this.sessionSub.unsubscribe() }
    if (this.userSub) { this.userSub.unsubscribe() }
    if (this.attachedTicketSub) { this.attachedTicketSub.unsubscribe() }
    this.stopNovaPolling();
  }

  getUsersName(userOrId: any) {
    if (!userOrId) {
      return this.translateService.instant('MAIN.SESSIONS.SESSION_DETAILS.USER_ROLES.UNKNOWN');
    }

    if (typeof userOrId === 'object' && userOrId.name) {
      return userOrId.name;
    }

    const user = this.users.find(u => u.id === userOrId);
    return user ? user.name : this.translateService.instant('MAIN.SESSIONS.SESSION_DETAILS.USER_ROLES.UNKNOWN');
  }

  onTicketClicked(id) {
    this.selectedTicket = id;
  }

  onAttachedTicketDetails() {
    if (!this.attachedTicketId) {
      return;
    }

    this.modalService.show(TicketDetailComponent, {
      initialState: {
        selectedTicket: {
          id: this.attachedTicketId,
          title: this.attachedTicket?.title || ''
        },
        mode: 'view'
      },
      class: 'modal-xl modal-dialog-centered',
      backdrop: 'static',
      animated: false
    });
  }

  onDetachFromTicket() {
    if (!this.attachedTicketId || !this.session?.id) {
      return;
    }

    const roomId = this.session?.room_id || this.session?.room?.id;
    if (!roomId) {
      return;
    }

    const initialState = {
      headerTitle: this.translateService.instant('MAIN.CONTENT.TICKETS.DETACH_SESSION'),
      textMessage: this.translateService.instant('MAIN.CONTENT.TICKETS.DETACH_SESSION_CONFIRM'),
      confirmButtonText: this.translateService.instant('MAIN.CONTENT.TICKETS.DETACH')
    };
    let alertmodalRef = this.modalService.show(AlertModalComponent, {
      initialState,
      backdrop: 'static',
      class: 'modal-dialog-centered',
      animated: false
    });
    alertmodalRef.content.onClose.subscribe(res => {
      if (res) {
        this.loaderService.show();
        this.ticketService.detachTicket(this.attachedTicketId, roomId, this.session.id)
          .then(() => {
            this.snackBarService.success(this.translateService.instant('MAIN.CONTENT.TICKETS.DETACH_SUCCESS'));
          })
          .catch(() => {
            this.snackBarService.error(this.translateService.instant('LOGIN.INTERNAL-ERROR'));
          })
          .finally(() => this.loaderService.hide());
      } else {
        alertmodalRef.hide();
      }
    });
  }

  generateUserNameWithRole(user: any, licenseType: string) {
    // if (this.accountDataSub) { this.accountDataSub.unsubscribe() }

    // this.accountDataSub = this.accountService.accountData
    // .subscribe(accountData => {
    //   licenseType = accountData.license.type;
    // })


    const username = user.ad_user ? user.user_principal_name : user.auth.username;
    if (user.coadmin) {
      user.name2 = `${user.name} (${username} / ${this.translateService.instant('MAIN.SESSIONS.SESSION_DETAILS.USER_ROLES.CO_ADMIN')})`;
      return user;
    }

    switch (user.role) {
      case "admin":
        user.name2 = `${user.name} (${username} / ${this.translateService.instant('MAIN.SESSIONS.SESSION_DETAILS.USER_ROLES.ADMIN')})`;
        return user;
      case "coadmin":
        user.name2 = `${user.name} (${username} / ${this.translateService.instant('MAIN.SESSIONS.SESSION_DETAILS.USER_ROLES.CO_ADMIN')})`;
        return user;
      case "expert":
        user.name2 = `${user.name} (${username} / ${this.translateService.instant('MAIN.SESSIONS.SESSION_DETAILS.USER_ROLES.EXPERT')})`;
        return user;
      default:
        user.name2 = `${user.name} (${username} / ${licenseType === "concurrent_user_based" ? this.translateService.instant('MAIN.SESSIONS.SESSION_DETAILS.USER_ROLES.USER') : this.translateService.instant('MAIN.SESSIONS.SESSION_DETAILS.USER_ROLES.SUBSCRIBER')})`;
        return user;
    }
  }

  onBackButton() {
    this.detailPageService.removeComponent();
  }

  onWipeSessionData() {
    const initialState = {
      headerTitle: this.translateService.instant('MAIN.SESSIONS.SESSION_DETAILS.WIPE_SESSION_DATA_MODAL.TITLE'),
      textMessage: this.translateService.instant('MAIN.SESSIONS.SESSION_DETAILS.WIPE_SESSION_DATA_MODAL.MESSAGE'),
      confirmButtonText: this.translateService.instant('MAIN.SESSIONS.SESSION_DETAILS.WIPE_SESSION_DATA_MODAL.WIPE'),
      confirmButtonStyle: "danger"
    };
    let alertmodalRef = this.modalService.show(AlertModalComponent, {
      initialState,
      backdrop: 'static',
      class: 'modal-dialog-centered',
      animated: false
    });
    this.subscriptions.push(alertmodalRef.content.onClose.subscribe(res => {
      if (res === true) {
        this.wipeSessionData();
      }
    }));
  }

  // ─── Nova Ingest ───

  onAddNova() {
    if (this.novaIsRequesting) return;

    const accountId = this.authService.currentUser.account_id;
    const roomId = this.session.room ? this.session.room.id : this.session.room_id;
    const sessionId = this.session.id;
    const force = this.novaStatus === 'error';

    this.novaIsRequesting = true;
    this.novaErrorMessage = null;

    this.novaIngestService.triggerIngest(accountId, roomId, sessionId, force)
      .then(data => {
        this.novaStatus = data.status;
        this.novaStatusMessage = data.statusMessage || data.message;
        if (!NOVA_TERMINAL_STATUSES.has(data.status)) {
          this.startNovaPolling();
        }
      })
      .catch(err => {
        const status = err?.status;
        if (status === 400) {
          this.novaErrorMessage = 'Invalid request parameters';
        } else if (status === 401) {
          this.novaErrorMessage = 'Authentication failed';
        } else if (status === 404) {
          this.novaErrorMessage = 'Session not found';
        } else {
          this.novaErrorMessage = err?.error?.message || 'Failed to start ingestion';
        }
        this.snackBarService.error(this.novaErrorMessage);
      })
      .finally(() => {
        this.novaIsRequesting = false;
      });
  }

  private fetchNovaIngestStatus() {
    this.novaIngestService.getJobStatus(this.session.id)
      .then(data => {
        this.novaStatus = data.status;
        this.novaStatusMessage = data.statusMessage;
        this.novaResult = data.result;
        this.novaErrorMessage = data.errorMessage;

        if (!NOVA_TERMINAL_STATUSES.has(data.status)) {
          this.startNovaPolling();
        } else {
          this.stopNovaPolling();
        }
      })
      .catch(err => {
        if (err?.status === 404) {
          this.novaStatus = null;
          this.novaStatusMessage = null;
          this.novaResult = null;
          this.novaErrorMessage = null;
        }
      })
      .finally(() => {
        this.novaInitialLoading = false;
      });
  }

  private startNovaPolling() {
    this.stopNovaPolling();
    this.novaPollTimer = setInterval(() => {
      this.novaIngestService.getJobStatus(this.session.id)
        .then(data => {
          this.novaStatus = data.status;
          this.novaStatusMessage = data.statusMessage;
          this.novaResult = data.result;
          this.novaErrorMessage = data.errorMessage;

          if (NOVA_TERMINAL_STATUSES.has(data.status)) {
            this.stopNovaPolling();
          }
        })
        .catch(err => {
          // Don't stop polling on transient network errors
          if (err?.status === 401) {
            this.stopNovaPolling();
          }
        });
    }, this.NOVA_POLL_INTERVAL);
  }

  private stopNovaPolling() {
    if (this.novaPollTimer !== null) {
      clearInterval(this.novaPollTimer);
      this.novaPollTimer = null;
    }
  }

  get novaButtonLabel(): string {
    if (this.novaInitialLoading || this.novaIsRequesting) return 'Loading...';
    if (this.novaStatus === null || this.novaStatus === 'deleted') return 'Add to Nova';
    if (this.novaStatus === 'ready') return 'Added to Nova ✓';
    if (this.novaStatus === 'error') return 'Retry';
    return 'Processing...';
  }

  get novaButtonDisabled(): boolean {
    if (this.novaInitialLoading || this.novaIsRequesting) return true;
    if (this.novaStatus === null || this.novaStatus === 'deleted') return false;
    if (this.novaStatus === 'error') return false;
    return true;
  }

  get novaIsProcessing(): boolean {
    return this.novaStatus !== null
      && !NOVA_TERMINAL_STATUSES.has(this.novaStatus);
  }

  onRemoveFromNova() {
    if (this.novaIsDeleting) return;

    const roomId = this.session.room ? this.session.room.id : this.session.room_id;
    const sessionId = this.session.id;

    this.novaIsDeleting = true;

    this.novaIngestService.deleteFromNova(sessionId, roomId)
      .then(() => {
        this.novaStatus = null;
        this.novaStatusMessage = null;
        this.novaResult = null;
        this.novaErrorMessage = null;
        this.novaConfirmRemove = false;
        this.snackBarService.success('Session removed from Nova');
      })
      .catch(err => {
        const status = err?.status;
        if (status === 409) {
          this.snackBarService.error('Cannot remove — ingestion is still in progress');
        } else {
          this.snackBarService.error(err?.error?.message || 'Failed to remove from Nova');
        }
      })
      .finally(() => {
        this.novaIsDeleting = false;
      });
  }

  onAttachToTicket() {
    const roomId = this.session.room ? this.session.room.id : this.session.room_id;
    const dataModel = {
      tickets: [],
      loading: true,
      initialTicketId: this.attachedTicketId
    };
    this.selectedTicket = this.attachedTicketId;
    this.loaderService.show();
    const ticketSub = this.ticketService.getRoomTicketList(roomId)
      .subscribe(tickets => {
        dataModel.tickets = tickets;
        dataModel.loading = false;
        this.loaderService.hide();
      });

    const modalId = this.templateModalService.show({
      template: this.pickTicketTemplate,
      context: {
        dataModel: dataModel,
        callbacks: {
          close: () => {
            this.selectedTicket = null;
            ticketSub.unsubscribe();
            if (dataModel.loading) {
              this.loaderService.hide();
            }
            this.templateModalService.hide(modalId);
          },
          attach: async () => {
            if (!this.selectedTicket) {
              return;
            }
            this.loaderService.show();

            try {
              // Eğer zaten başka bir ticket'a bağlıysa, önce detach et
              if (this.attachedTicketId && this.attachedTicketId !== this.selectedTicket) {
                await this.ticketService.detachTicket(this.attachedTicketId, roomId, this.session.id);
              }

              // Yeni ticket'a attach et
              await this.ticketService.attachTicket(this.selectedTicket, roomId, this.session.id);

              this.attachedTicketId = this.selectedTicket;
              this.refreshAttachedTicket();
              ticketSub.unsubscribe();
              this.templateModalService.hide(modalId);
              this.snackBarService.success(this.translateService.instant('MAIN.CONTENT.TICKETS.ATTACH_SUCCESS'));
            } catch (error) {
              if (error?.status === 409 || error?.error === 'session-already-attached') {
                this.snackBarService.error(this.translateService.instant('MAIN.CONTENT.TICKETS.SESSION_ALREADY_ATTACHED'));
                return;
              }
              this.snackBarService.error(this.translateService.instant('LOGIN.INTERNAL-ERROR'));
            } finally {
              this.loaderService.hide();
            }
          }
        }
      }
    });
  }

  private refreshAttachedTicket() {
    if (this.attachedTicketSub) {
      this.attachedTicketSub.unsubscribe();
      this.attachedTicketSub = null;
    }

    if (!this.ticketAvailable || !this.attachedTicketId) {
      this.attachedTicket = null;
      return;
    }

    this.attachedTicketSub = this.ticketService.getTicketData(this.attachedTicketId)
      .subscribe(ticket => {
        this.attachedTicket = ticket;
      });
  }

  wipeSessionData() {
    this.loaderService.show();
    const roomId = this.session.room ? this.session.room.id : this.session.room_id;
    this.sessionService.wipeSessionData(this.session.id, roomId)
      .then(() => {
        this.snackBarService.success(this.translateService.instant('MAIN.SESSIONS.SESSION_DETAILS.WIPE_SESSION_DATA_MODAL.WIPE_SUCCEEDED'));
        this.session.session_files_deleted = true;
      })
      .catch(error => {
        console.log(error);
        this.snackBarService.error(this.translateService.instant('MAIN.SESSIONS.SESSION_DETAILS.WIPE_SESSION_DATA_MODAL.WIPE_FAILED'));
      })
      .finally(() => this.loaderService.hide());
  }


  // onAttachToTicket() {
  //   const dataModel = { tickets: [] };
  //   const ticketSub = this.ticketService.getRoomTicketList(this.session.room_id)
  //   .subscribe(tickets => { dataModel.tickets = tickets; });

  //   const modalId = this.modalService.show({
  //     template: this.pickTicketTemplate,
  //     context: {
  //       dataModel: dataModel,
  //       callbacks: {
  //         close: () => {
  //           this.selectedTicket = null;
  //           ticketSub.unsubscribe();
  //           this.modalService.hide(modalId);
  //         },
  //         attach: () => {
  //           this.loaderService.show();
  //           this.ticketService.attachTicket(this.selectedTicket, this.session.room_id, this.session.id)
  //           .then(() => {
  //             ticketSub.unsubscribe();
  //             this.modalService.hide(modalId);
  //           })
  //           .catch(error => this.flashMessageService.show('There is an error occured.'))
  //           .finally(() => this.loaderService.hide());
  //         }
  //       }
  //     }
  //   });
  // }
}
